<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:0em">To my wife Carol for her enthusiasm, encouragement and skill in correcting my grammar. Thank you is an insufficient word to express my gratitude.</p><br/>
<p style="text-indent:0em">To my many surgical colleagues and all the patients who placed their trust in me. Without them none of the events described would have taken place.</p><br/>
<p style="text-indent:0em">To the endlessly patient staff of Austin Macauley who guided me through the unfamiliar world of publication. Thank you for bringing this work to fruition.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?7da198eb